import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { StyleSheetManager } from 'styled-components';

import { RouterProvider } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { persistor, store } from './store/store';
import CustomThemeProvider from './theme/theme.provider';
import './messaging_init_in_sw';

// ------------------------
// 1. Inizializzazione Datadog RUM
// ------------------------
datadogRum.init({
    applicationId: '8196fa92-edce-4420-9589-b7b69ed62508',
    clientToken: 'pub85b3e916437eccb9107e7c15246ac2d2',
    site: 'datadoghq.eu',
    service: 'primi-mille-giorni-pwa',
    env: process.env.NODE_ENV === 'development' ? 'dev' : 'prod',
    version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [reactPlugin({ router: true })],
});

// ------------------------
// 2. Creazione del router con Datadog-aware plugin
// ------------------------
const router = createBrowserRouter([
    {
        path: '/*',
        element: (
            <StyleSheetManager
                shouldForwardProp={(prop) =>
                    ![
                        'selectedItem',
                        'index',
                        'selected',
                        'time',
                        'show',
                        'pageIndex',
                        'disabled',
                        'lestIndex',
                    ].includes(prop)
                }
            >
                <CustomThemeProvider>
                    <Provider store={store}>
                        <PersistGate loading={null} persistor={persistor}>
                            <App />
                        </PersistGate>
                    </Provider>
                </CustomThemeProvider>
            </StyleSheetManager>
        ),
    },
]);

// ------------------------
// 3. Montaggio root
// ------------------------
const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>
);

// ------------------------
// 4. Service Worker & Web Vitals
// ------------------------
serviceWorkerRegistration.register();
reportWebVitals();
